import { DEFAULT_DESIGN_ID } from './designTemplates';

const DECK_ID_KEY = 'spotdove-active-deck-id';
const DECK_NAME_KEY = 'spotdove-active-deck-name';
const DECK_DESIGN_KEY = 'spotdove-active-deck-design';
const DECK_LOGO_KEY = 'spotdove-active-deck-logo';

export const loadActiveDeckId = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.localStorage.getItem(DECK_ID_KEY);
};

export const loadActiveDeckName = (): string => {
  if (typeof window === 'undefined') {
    return 'Untitled deck';
  }
  return window.localStorage.getItem(DECK_NAME_KEY) ?? 'Untitled deck';
};

export const loadActiveDeckDesignId = (): string => {
  if (typeof window === 'undefined') {
    return DEFAULT_DESIGN_ID;
  }
  return window.localStorage.getItem(DECK_DESIGN_KEY) ?? DEFAULT_DESIGN_ID;
};

export const loadActiveDeckLogoUrl = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.localStorage.getItem(DECK_LOGO_KEY);
};

export const saveActiveDeckLogoUrl = (logoUrl: string | null): void => {
  if (typeof window === 'undefined') {
    return;
  }
  if (logoUrl) {
    window.localStorage.setItem(DECK_LOGO_KEY, logoUrl);
  } else {
    window.localStorage.removeItem(DECK_LOGO_KEY);
  }
};

export const saveActiveDeck = (
  id: string,
  name: string,
  designId: string,
  logoUrl?: string | null,
): void => {
  window.localStorage.setItem(DECK_ID_KEY, id);
  window.localStorage.setItem(DECK_NAME_KEY, name);
  window.localStorage.setItem(DECK_DESIGN_KEY, designId);
  saveActiveDeckLogoUrl(logoUrl ?? null);
};

export const saveActiveDeckDesignId = (designId: string): void => {
  window.localStorage.setItem(DECK_DESIGN_KEY, designId);
};

export const saveActiveDeckName = (name: string): void => {
  window.localStorage.setItem(DECK_NAME_KEY, name);
};

export const clearActiveDeck = (): void => {
  window.localStorage.removeItem(DECK_ID_KEY);
  window.localStorage.removeItem(DECK_NAME_KEY);
  window.localStorage.removeItem(DECK_DESIGN_KEY);
  window.localStorage.removeItem(DECK_LOGO_KEY);
};
